// 小米锁屏
export default {
  // 孟加拉语
  "bn-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192497663-0",
        slot: "/23161678951/bn_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 6114639712,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744367225087-0",
        // slot: "/23161678951/bn_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/bn_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 7678453115,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 1048092433,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367143396-0",
        slot: "/23161678951/bn_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 1847541938,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367160785-0",
        slot: "/23161678951/bn_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 9534460269,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367178314-0",
        slot: "/23161678951/bn_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 1113044768,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367203902-0",
        slot: "/23161678951/bn_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 希腊语
  "el-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192545976-0",
        slot: "/23161678951/el_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9162107908,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744367341963-0",
        // slot: "/23161678951/el_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/el_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 8543439077,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 9016381679,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367263594-0",
        slot: "/23161678951/el_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7703300007,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367282318-0",
        slot: "/23161678951/el_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 6908296920,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367301846-0",
        slot: "/23161678951/el_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 5917275734,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367323163-0",
        slot: "/23161678951/el_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 希伯来语
  "he-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192567035-0",
        slot: "/23161678951/he_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4228270024,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744367454748-0",
        // slot: "/23161678951/he_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/he_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 6390218331,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8859133849,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367375513-0",
        slot: "/23161678951/he_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7546052177,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367397475-0",
        slot: "/23161678951/he_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 5982228060,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367415445-0",
        slot: "/23161678951/he_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 3606807164,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367436417-0",
        slot: "/23161678951/he_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 韩语
  "ko-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192607790-0",
        slot: "/23161678951/ko_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9018637675,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744367842114-0",
        // slot: "/23161678951/ko_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/ko_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 8416819712,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 1655970241,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367757588-0",
        slot: "/23161678951/ko_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7103738043,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367775652-0",
        slot: "/23161678951/ko_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 8888389164,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367798332-0",
        slot: "/23161678951/ko_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 7575307495,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367821977-0",
        slot: "/23161678951/ko_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 乌克兰语
  "uk-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192825821-0",
        slot: "/23161678951/uk_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4181228057,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744367956549-0",
        // slot: "/23161678951/uk_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/uk_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 1851411360,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8225248028,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367883234-0",
        slot: "/23161678951/uk_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 6912166350,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367901033-0",
        slot: "/23161678951/uk_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4286003012,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367918651-0",
        slot: "/23161678951/uk_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 2259401630,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367937379-0",
        slot: "/23161678951/uk_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 缅甸语
  "my-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192648554-0",
        slot: "/23161678951/my_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 8264237476,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "ads",
        slot: 8029806901,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-09",
      },
      {
        type: "ads",
        slot: 1698829121,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-13",
      },
      {
        type: "ads",
        slot: 8072665781,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-14",
      },
      {
        type: "ads",
        slot: 6007074952,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 俄语
  "ru-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192711436-0",
        slot: "/23161678951/ru_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 3565925047,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368068446-0",
        // slot: "/23161678951/ru_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/ru_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 7131119209,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2820339108,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744367994139-0",
        slot: "/23161678951/ru_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 9214357068,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368011529-0",
        slot: "/23161678951/ru_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 6588193720,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368029341-0",
        slot: "/23161678951/ru_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 5275112057,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368048050-0",
        slot: "/23161678951/ru_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 俄语
  "rs-mils.comfortweather.com": {
    ad1: [
      {
        type: "dex",
        // lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175448894420287369",
        p1: "djjki",
        p2: "jfhk",
        position: "position-08",
      },
    ],
    floorAd: [
      {
        type: "floorAd",
        ownerId: 11635561,
        containerId: "adfox_175448882200227369",
        platform: "touch",
        p1: "djjkh",
        p2: "jkqc",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175448898441617369",
        p1: "djjkj",
        p2: "jfhl",
        position: "position-16",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175448901346567369",
        p1: "djjkk",
        p2: "jfhl",
        position: "position-17",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175448903881077369",
        p1: "djjkl",
        p2: "jfhl",
        position: "position-18",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175448906396837369",
        p1: "djjkm",
        p2: "jfhl",
        position: "position-19",
      },
    ],
  },
  // 阿塞拜疆语
  "az-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192459538-0",
        slot: "/23161678951/az_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 2915188353,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368194776-0",
        // slot: "/23161678951/az_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/az_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 5403643562,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8696817472,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368100281-0",
        slot: "/23161678951/az_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 2777480221,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368118566-0",
        slot: "/23161678951/az_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 1464398554,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368136154-0",
        slot: "/23161678951/az_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 6556404133,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368176926-0",
        slot: "/23161678951/az_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 匈牙利语
  "hu-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192587631-0",
        slot: "/23161678951/hu_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4418414663,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368302970-0",
        // slot: "/23161678951/hu_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/hu_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 8204527722,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 3819895312,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368230068-0",
        slot: "/23161678951/hu_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 3463837943,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368248541-0",
        slot: "/23161678951/hu_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 2437195729,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368265773-0",
        slot: "/23161678951/hu_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 8811032386,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368283097-0",
        slot: "/23161678951/hu_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 罗马尼亚语
  "ro-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192689975-0",
        slot: "/23161678951/ro_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9050411351,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368412020-0",
        // slot: "/23161678951/ro_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/ro_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 2315241957,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 7375996942,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368340533-0",
        slot: "/23161678951/ro_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 3252919104,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368358375-0",
        slot: "/23161678951/ro_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 8959745193,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368375141-0",
        slot: "/23161678951/ro_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 4749833604,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368392173-0",
        slot: "/23161678951/ro_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 塞尔维亚语
  "sr-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192782736-0",
        slot: "/23161678951/sr_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 5881097191,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368568388-0",
        // slot: "/23161678951/sr_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/sr_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 1112505769,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8799424093,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368498080-0",
        slot: "/23161678951/sr_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 4860179085,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368514271-0",
        slot: "/23161678951/sr_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 3436751936,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368532383-0",
        slot: "/23161678951/sr_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 2234015743,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368551162-0",
        slot: "/23161678951/sr_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 保加利亚语
  "bg-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192479423-0",
        slot: "/23161678951/bg_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 3254933853,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368677295-0",
        // slot: "/23161678951/bg_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/bg_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 9646102919,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 3428216910,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368606886-0",
        slot: "/23161678951/bg_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 9563176585,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368624152-0",
        slot: "/23161678951/bg_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4773884332,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368644368-0",
        slot: "/23161678951/bg_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 3460802667,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368660305-0",
        slot: "/23161678951/bg_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 斯洛伐克语
  "sk-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192759867-0",
        slot: "/23161678951/sk_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9230390665,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744368807575-0",
        // slot: "/23161678951/sk_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/sk_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 6937013244,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8521557657,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368708766-0",
        slot: "/23161678951/sk_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 8497506927,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368743508-0",
        slot: "/23161678951/sk_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 9371604896,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368762252-0",
        slot: "/23161678951/sk_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 6745441555,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744368783605-0",
        slot: "/23161678951/sk_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 繁体中文
  "zh-hant-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192844187-0",
        slot: "/23161678951/zh-hant_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 1171921337,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744614085271-0",
        // slot: "/23161678951/zh_hant_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/zh_hant_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 9643067634,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 7455091839,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744613994275-0",
        slot: "/23161678951/zh_hant_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 4119278216,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614017031-0",
        slot: "/23161678951/zh_hant_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 8619460699,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614041412-0",
        slot: "/23161678951/zh_hant_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 4680215681,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614064505-0",
        slot: "/23161678951/zh_hant_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 僧伽罗语
  "si-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192738096-0",
        slot: "/23161678951/si_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 6232676326,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744625643016-0",
        // slot: "/23161678951/si_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/si_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 5862808562,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6825332609,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614125638-0",
        slot: "/23161678951/si_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 6883707197,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614146500-0",
        slot: "/23161678951/si_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 7675379846,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614172708-0",
        slot: "/23161678951/si_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 3736134839,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614197340-0",
        slot: "/23161678951/si_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 捷克语
  "cs-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1742192526275-0",
        slot: "/23161678951/cs_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 2913761300,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744614342272-0",
        // slot: "/23161678951/cs_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/cs_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        // type: "ads",
        // slot: 1932098571,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 1064404301,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614231734-0",
        slot: "/23161678951/cs_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 5320679245,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614251392-0",
        slot: "/23161678951/cs_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4007597578,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614273611-0",
        slot: "/23161678951/cs_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 8796889824,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744614294886-0",
        slot: "/23161678951/cs_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 巴西葡萄牙语
  "pt-br-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763404972-0",
        slot: "/23161678951/pt_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4907289897,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744339322572-0",
        // slot: "/23161678951/pt_br_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/pt_br_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 1833578613,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2754382811,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339236250-0",
        slot: "/23161678951/pt_br_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 2127696858,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339260885-0",
        slot: "/23161678951/pt_br_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 2057041525,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339280498-0",
        slot: "/23161678951/pt_br_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 2534890965,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339298486-0",
        slot: "/23161678951/pt_br_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 欧洲-葡萄牙语
  "pt-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763388669-0",
        slot: "/23161678951/pt_br_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 2281126552,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744339435515-0",
        // slot: "/23161678951/pt_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/pt_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 2763516904,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 1221809291,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339356848-0",
        slot: "/23161678951/pt_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7188451843,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339374683-0",
        slot: "/23161678951/pt_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 6734653135,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339395964-0",
        slot: "/23161678951/pt_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 5421571469,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339414141-0",
        slot: "/23161678951/pt_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 西班牙语
  "es-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763251083-0",
        slot: "/23161678951/es_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 5134520605,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744339553510-0",
        // slot: "/23161678951/es_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/es_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 5564378980,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2343319271,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339465904-0",
        slot: "/23161678951/es_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 1482326454,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339482331-0",
        slot: "/23161678951/es_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 3057635149,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339510324-0",
        slot: "/23161678951/es_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 6838493282,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339534989-0",
        slot: "/23161678951/es_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 阿拉伯语
  "arabic-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763216410-0",
        slot: "/23161678951/arabic_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 6990495931,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744339924956-0",
        // slot: "/23161678951/arabic_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/arabic_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 7926818447,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6543081444,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339592377-0",
        slot: "/23161678951/arabic_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 5492226790,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339610532-0",
        slot: "/23161678951/arabic_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4777910927,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339878103-0",
        slot: "/23161678951/arabic_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 5229999775,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744339901140-0",
        slot: "/23161678951/arabic_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 土耳其语
  "tr-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763442413-0",
        slot: "/23161678951/tr_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9973845949,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365350513-0",
        // slot: "/23161678951/tr_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/tr_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 7998970638,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6613736770,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365288107-0",
        slot: "/23161678951/tr_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 2938215643,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365308351-0",
        slot: "/23161678951/tr_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 9838665913,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365326844-0",
        slot: "/23161678951/tr_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 4997402773,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365370137-0",
        slot: "/23161678951/tr_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 法语
  "fr-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763271650-0",
        slot: "/23161678951/fr_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 1462868907,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365492542-0",
        // slot: "/23161678951/fr_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/fr_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 5181235607,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6685888967,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365411193-0",
        slot: "/23161678951/fr_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7212502577,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365435115-0",
        slot: "/23161678951/fr_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 2371239437,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365455345-0",
        slot: "/23161678951/fr_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 9048328423,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365474937-0",
        slot: "/23161678951/fr_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 意大利语
  "it-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763333363-0",
        slot: "/23161678951/it_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9149787237,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365610409-0",
        // slot: "/23161678951/it_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/it_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 1394594910,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2555072262,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365533012-0",
        slot: "/23161678951/it_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 4586339237,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365549955-0",
        slot: "/23161678951/it_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 3273257569,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365568650-0",
        slot: "/23161678951/it_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 4846856397,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365590762-0",
        slot: "/23161678951/it_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 乌尔都语
  "urdu-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763458252-0",
        slot: "/23161678951/urdu_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4721519264,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365723969-0",
        // slot: "/23161678951/urdu_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/urdu_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 3492749414,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 3796001743,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365644874-0",
        slot: "/23161678951/urdu_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 6455349902,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365667626-0",
        slot: "/23161678951/urdu_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4989663913,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365685459-0",
        slot: "/23161678951/urdu_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 9647094227,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365706244-0",
        slot: "/23161678951/urdu_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 越南语
  "vi-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763474559-0",
        slot: "/23161678951/vi_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 6523623890,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365841338-0",
        // slot: "/23161678951/vi_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1747981793463-0",
        // slot: "/23161678951/vi_mils_comfortweather_20250523_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/vi_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 1266041322,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2179667743,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365761805-0",
        slot: "/23161678951/vi_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7281448042,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365781654-0",
        slot: "/23161678951/vi_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4394767548,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365801172-0",
        slot: "/23161678951/vi_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 9866586077,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365824217-0",
        slot: "/23161678951/vi_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 泰语
  "th-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763423406-0",
        slot: "/23161678951/th_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 7156110917,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744365953544-0",
        // slot: "/23161678951/th_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/th_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 2171928881,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8553504401,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365872614-0",
        slot: "/23161678951/th_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7240422731,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365890565-0",
        slot: "/23161678951/th_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 5465701868,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365913258-0",
        slot: "/23161678951/th_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 7639877989,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744365932514-0",
        slot: "/23161678951/th_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 英语
  "en-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763232414-0",
        slot: "/23161678951/en_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 3629867245,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744366335051-0",
        // slot: "/23161678951/en_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 1980357197,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 1526456855,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366244658-0",
        slot: "/23161678951/en_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 7232683874,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366267305-0",
        slot: "/23161678951/en_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 6587211843,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366288155-0",
        slot: "/23161678951/en_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 4725940039,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366309706-0",
        slot: "/23161678951/en_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 日语
  "jp-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763352919-0",
        slot: "/23161678951/jp_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 3300626381,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744366466527-0",
        // slot: "/23161678951/jp_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/jp_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 6637787503,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2890114182,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366370505-0",
        slot: "/23161678951/jp_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 9667275528,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366401164-0",
        slot: "/23161678951/jp_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4422687702,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366419527-0",
        slot: "/23161678951/jp_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 2647966836,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366444912-0",
        slot: "/23161678951/jp_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 德语
  "ger-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763297077-0",
        slot: "/23161678951/ger_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4529947575,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744366623927-0",
        // slot: "/23161678951/ger_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/ger_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 5544197684,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 5082558488,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366512694-0",
        slot: "/23161678951/ger_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 3101867177,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366532790-0",
        slot: "/23161678951/ger_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4822142951,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366580744-0",
        slot: "/23161678951/ger_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 9786695027,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366604542-0",
        slot: "/23161678951/ger_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 印尼语
  "id-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763314191-0",
        slot: "/23161678951/id_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 3322745481,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744366850504-0",
        // slot: "/23161678951/id_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/id_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 5865458435,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6678451423,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366777078-0",
        slot: "/23161678951/id_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 8184500010,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366794392-0",
        slot: "/23161678951/id_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 5138139049,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366811926-0",
        slot: "/23161678951/id_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 5785567389,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366831517-0",
        slot: "/23161678951/id_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 波兰语
  "po-mils.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1741763370119-0",
        slot: "/23161678951/po_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 2089554862,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1744366744580-0",
        // slot: "/23161678951/po_mils_comfortweather_20250410_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/po_mils_comfortweather_20250724_bottomanchor",
        position: "position-01",
      },
      {
        //   type: "ads",
        //   slot: 5127462965,
        //   style: {
        //     display: "inline-block",
        //     width: "320px",
        //     height: "100px",
        //   },
        //   position: "",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 2852092339,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366661324-0",
        slot: "/23161678951/po_mils_comfortweather_20250410_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 3311818411,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366677898-0",
        slot: "/23161678951/po_mils_comfortweather_20250410_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 9685655079,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366703185-0",
        slot: "/23161678951/po_mils_comfortweather_20250410_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 9250540808,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        type: "adx",
        id: "div-gpt-ad-1744366723499-0",
        slot: "/23161678951/po_mils_comfortweather_20250410_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
};
